import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutEquipmentTypeLookup extends Layout {
    sourceEquipmentType: DataSource;
    tableEquipmentType: Table;
}
